import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FamilyService } from '../../../backend/api/family.service';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { FamilyRequestDto } from './../../../backend/model/familyRequestDto';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  templateUrl: './save-family-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})
export class SaveFamilyDialogComponent extends BaseComponent {
  form = new UntypedFormGroup({});
  id = 0;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private familiesService: FamilyService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;

    this.form = new UntypedFormGroup({
      representative: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      city: new UntypedFormControl('', [Validators.required]),
      documents: new UntypedFormControl(),
      residence: new UntypedFormControl(),
      id: new UntypedFormControl(),
    });

    if (this.id) {
      this.loadUser(this.id);
    }
  }

  loadUser(id: number) {
    this.isLoading = true;

    this.familiesService.apiFamilyIdGet({ id }).subscribe(
      (res) => {
        this.isLoading = false;
        this.form.patchValue({
          representative: res.representative,
          phone: res.phone,
          address: res.address,
          city: res.city,
          documents: res.documents || false,
          residence: res.residence,
          id: res.id
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }

      return;
    }
    
    const data: FamilyRequestDto = {
      representative: this.form.value.representative,
      phone: this.form.value.phone,
      address: this.form.value.address,
      city: this.form.value.city,
      documents: this.form.value.documents,
      residence: this.form.value.residence,
      id: this.form.value.id,
    };

    const apiCall = this.id
      ? this.familiesService.apiFamilyPut({
          familyRequestDto: data,
        })
      : this.familiesService.apiFamilyPost({ familyRequestDto: data });

    this.isSaving = true;

    apiCall.subscribe(
      (res: any) => {
        this.isSaving = false;
        this.close(true);
      },
      (err: HttpErrorResponse) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }
}
